var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5H16.2703C15.9941 23.5 15.7703 23.2761 15.7703 23V15.7987C15.7703 13.7165 14.0823 12.0285 12 12.0285C9.91774 12.0285 8.22973 13.7165 8.22973 15.7988V23C8.22973 23.2761 8.00587 23.5 7.72973 23.5H4C2.61929 23.5 1.5 22.3807 1.5 21V9.27766C1.5 9.09949 1.59345 8.9341 1.74831 8.84104C2.77687 8.22303 5.22267 6.72348 6.80544 5.50223C8.47868 4.21117 10.5536 2.17728 11.6258 1.09699C11.8313 0.889995 12.1687 0.889995 12.3742 1.097C13.4464 2.17728 15.5213 4.21117 17.1946 5.50223C18.7773 6.72348 21.2231 8.22303 22.2517 8.84104C22.4066 8.9341 22.5 9.09949 22.5 9.27766V21C22.5 22.3807 21.3807 23.5 20 23.5Z",
    fill: "none",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabHome);
export default __webpack_public_path__ + "static/media/tab_home.3e4f78ab.svg";
export { ForwardRef as ReactComponent };